import moment from 'moment'

export default {
  getList (VueApp, callback) {
    let pageData = VueApp.$store.state.corporate.users
    VueApp.$sdk.get('/admin/corporateprofile', {
      token: VueApp.$store.state.session.sessionToken,
      orderAsc: pageData.orderAsc,
      order: pageData.order,
      pageNum: pageData.currentPage,
      pageSize: pageData.perPage,
      search: pageData.search
    }, res => {
      if (!res.error) {
        // VueApp.$store.commit('corporate/setUserMaxList', res.paging.totalItems)

        if (res.list.length) {
          let users = []
          for (let i = 0; i < res.list.length; i++) {
            let userInfo = res.list[i]
            let created = moment(userInfo.created, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY')
            // if (userInfo.created === null) { created = 'N/A' }
            // let phone = userInfo.phone ? userInfo.countryCode + '' + userInfo.phone : ''
            let stripeUrl = ''
            if (userInfo.customer && userInfo.customer.customerURL) {
              stripeUrl = userInfo.customer.customerURL
            }
            users.push({
              id: userInfo.id,
              name: userInfo.name,
              username: userInfo.username,
              email: userInfo.contactEmail,
              mobile: userInfo.contactPhone,
              created: created,
              logo: userInfo.logoUrl,
              stripeUrl: stripeUrl,
              active: userInfo.active === 1
            })
          }

          VueApp.$store.commit('corporate/addUsers', users)

          /* DELETE LATER */
          // let maxList = (pageData.currentPage + 1) * pageData.perPage
          // if (res.list.length < pageData.perPage) {
          //   if (pageData.currentPage === 1) {
          //     maxList = (1 * pageData.perPage) + res.list.length
          //   } else {
          //     maxList = ((pageData.currentPage - 1) * pageData.perPage) + res.list.length
          //   }
          // }
          VueApp.$store.commit('corporate/setUserMaxList', res.paging.totalItems)
        }
      }
      callback(res)
    })
  }
}
  


// WEBPACK FOOTER //
// ./src/modules/api/corporate/list.js